import apiClient from 'shared/api/client';
import { API_ROUTES } from 'shared/constants/api';

export interface Membership {
  id: number;
  counterparty_id: number;
  counterparty_name: string | null;
  role_id: number;
  role_name: string;
  role_description: string | null;
}

export interface ContextResponse {
  active_membership_id: number | null;
  active_counterparty_id: number | null;
  active_role: string | null;
  memberships: Membership[];
}

export async function fetchMemberships(): Promise<ContextResponse> {
  const res = await apiClient.get<ContextResponse>(API_ROUTES.auth.memberships);
  return res.data;
}

export async function switchContext(membershipId: number): Promise<ContextResponse> {
  const res = await apiClient.post<ContextResponse>(API_ROUTES.auth.context, { membership_id: membershipId });
  return res.data;
}
